import styled from 'styled-components';
import { RatingChip } from '../DishFirstCard';

export const ShefRatingChip = styled(RatingChip)`
  box-shadow: none;
`;
